import { authLegacyAlternates, authLegacyFixtures } from './auth-alternates';
import { consentCategoryLegacyAlternates, consentCategoryLegacyFixtures } from './consent-category-alternates';
import { eventNameLegacyAlternates, eventNameLegacyFixtures } from './event-name-alternates';
import { eventSchemaLegacyAlternates, eventSchemaLegacyFixtures } from './event-schema-alternates';
import { integrationLegacyAlternates, integrationLegacyFixtures } from './integration-alternates';
import { pipelineLegacyAlternates, pipelineLegacyFixtures } from './pipeline-alternates';
import { pipelineEventLegacyAlternates, pipelineEventLegacyFixtures } from './pipeline-event-alternates';
import {
  pipelineIntegrationLegacyAlternates,
  pipelineIntegrationLegacyFixtures,
} from './pipeline-integration-alternates';
import {
  pipelineSchemaLibraryLegacyAlternates,
  pipelineSchemaLibraryLegacyFixtures,
} from './pipeline-schema-library-alternates';
import { pipelineTagLegacyAlternates, pipelineTagLegacyFixtures } from './pipeline-tag-alternates';
import { sampleEventLegacyAlternates, sampleEventLegacyFixtures } from './sample-event-alternates';
import { schemaLegacyAlternates, schemaLegacyFixtures } from './schema-alternates';
import { schemaLibraryLegacyAlternates, schemaLibraryLegacyFixtures } from './schema-library-alternates';
import { stagedRevisionLegacyAlternates, stagedRevisionLegacyFixtures } from './staged-revision-alternates';
import { tagLegacyAlternates, tagLegacyFixtures } from './tag-alternates';
import { userLegacyAlternates, userLegacyFixtures } from './user-alternates';

export const legacyFamilies = [
  { alternates: authLegacyAlternates, fixtures: authLegacyFixtures },
  { alternates: consentCategoryLegacyAlternates, fixtures: consentCategoryLegacyFixtures },
  { alternates: eventNameLegacyAlternates, fixtures: eventNameLegacyFixtures },
  { alternates: eventSchemaLegacyAlternates, fixtures: eventSchemaLegacyFixtures },
  { alternates: integrationLegacyAlternates, fixtures: integrationLegacyFixtures },
  { alternates: pipelineLegacyAlternates, fixtures: pipelineLegacyFixtures },
  { alternates: pipelineEventLegacyAlternates, fixtures: pipelineEventLegacyFixtures },
  { alternates: pipelineIntegrationLegacyAlternates, fixtures: pipelineIntegrationLegacyFixtures },
  { alternates: pipelineSchemaLibraryLegacyAlternates, fixtures: pipelineSchemaLibraryLegacyFixtures },
  { alternates: pipelineTagLegacyAlternates, fixtures: pipelineTagLegacyFixtures },
  { alternates: sampleEventLegacyAlternates, fixtures: sampleEventLegacyFixtures },
  { alternates: schemaLegacyAlternates, fixtures: schemaLegacyFixtures },
  { alternates: schemaLibraryLegacyAlternates, fixtures: schemaLibraryLegacyFixtures },
  { alternates: stagedRevisionLegacyAlternates, fixtures: stagedRevisionLegacyFixtures },
  { alternates: tagLegacyAlternates, fixtures: tagLegacyFixtures },
  { alternates: userLegacyAlternates, fixtures: userLegacyFixtures },
];

export const legacyMap = Object.assign({}, ...legacyFamilies.map(family => family.alternates));

export const legacyFixtures = Object.assign({}, ...legacyFamilies.map(family => family.fixtures));
